import React, { useState } from "react";
import ReusableTable from "../../../Reuseable/ReusableTable/ReusableTable";
import AgentDetailsModal from "../AgentDetailsModal/AgentDetailsModal";
import "./AgentDetailsTable.scss"
import { render } from "@testing-library/react";
import { Skeleton } from "antd";

const AgentDetailsTable = ({ data, loading }) => {
  const [pageSize, setPageSize] = useState(10);
  const [modalOpen, setModalOpen] = useState(false); // ✅ define modal state
  const [selectedAgent, setSelectedAgent] = useState(null); // ✅ define selected agent state

  const handleViewClick = (record) => {
    setSelectedAgent(record);
    setModalOpen(true);
  };


const renderWithSkeleton = (text) =>
  loading ? <Skeleton.Input active size="small" style={{ width: 100 }} /> : (text || "N/A");


 const columns = [
  {
    title: "Customer Name",
    dataIndex: "customer_name",
    key: "customer_name",
    render: renderWithSkeleton,
  },
  {
    title: "Loan No.",
    dataIndex: "loan_no",
    key: "loan_no",
    render: renderWithSkeleton,
  },
  {
    title: "Bucket",
    dataIndex: "bucket",
    key: "bucket",
    render: renderWithSkeleton,
  },
  {
    title: "Amount Overdue",
    dataIndex: "amount_overdue",
    key: "amount_overdue",
    render: renderWithSkeleton,
  },
  {
    title: "Bank",
    dataIndex: "bank_name",
    key: "bank_name",
    render: renderWithSkeleton,
  },
  {
    title: "Product",
    dataIndex: "product",
    key: "product",
    render: renderWithSkeleton,
  },
  {
    title: "Actions",
    key: "actions",
    render: (_, record) => (
      <button className="viewBtn" onClick={() => handleViewClick(record)}>
        Details
      </button>
    ),
  },
];


  // const data = Array.from({ length: 10 }, (_, i) => {
  //   const day = (i % 28) + 1; // day between 1-28
  //   return {
  //     key: i.toString(),
  //     customer_name: `Guy Hawkins ${i + 1}`,
  //     loan_no: "RARCRA200000038910",
  //     bucket: "3651",
  //     amount_overdue: `76994.0`, // ✅ dynamic date
  //     bank: `Reliance ARC`,
  //     product:"Student Loan",
  //     draRegNo: "0000002",
  //   };
  // });

  return (
    <div className="agent-detail-table">
      <ReusableTable
        columns={columns}
        dataSource={loading ? Array(7).fill({}) : data?.results}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalItems={data.length}
      />
      <AgentDetailsModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        agent={selectedAgent}
      />
    </div>
  );
};

export default AgentDetailsTable;
